import { Component, EventEmitter, Inject, OnInit, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Subscription, Observable, of } from "rxjs";
import { AdminService } from "src/app/pages/admin/admin-service";
import { map } from "rxjs/internal/operators/map";
import { startWith, debounceTime, switchMap, catchError } from "rxjs/operators";
import Swal from "sweetalert2";
import { MixinFunctionsService } from "src/app/pages/services/mixin-functions.service";

@Component({
  selector: "app-user-dialog",
  templateUrl: "./user-dialog.component.html",
  styleUrls: ["./user-dialog.component.scss"],
})
export class UserDialogComponent implements OnInit {
  saveFunction = new EventEmitter();

  adminAreas: Observable<string>;
  roleIds: any = [];

  formsControl = new FormControl();
  form: FormGroup;
  subs: Subscription[] = [];
  list: any;
  selected: any;
  public searched$: Observable<any> = null;

  constructor(
    public dialogRef: MatDialogRef<UserDialogComponent>,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public mixins: MixinFunctionsService,
    @Inject(MAT_DIALOG_DATA) public formData,
    public roleApi: AdminService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  get title() {
    if (this.formData.id) {
      return "Update";
    } else {
      return "Add";
    }
  }

  save() {
    /** if user is updating data and role not changed then save mapped roles */
    if (this.formData.id && this.formData.roles && this.roleIds.length === 0) {
      this.roleIds = this.formData.roles.map((r) => r.id);
    }

    // Validate user if has a selected Admin area
    //check if user has selected Roles
    if (this.roleIds.length === 0) {
      return this.form.controls["roles"].setErrors({ noRoles: true });
    } else {
      this.form.controls["roles"].clearValidators();
      this.form.controls["roles"].updateValueAndValidity();
    }

    if ((this.formData.adminArea || this.formData.adminAreaId) === undefined) {
      return this.form.controls["adminArea"].setErrors({ noAdminArea: true });
    } else {
      this.form.controls["adminArea"].clearValidators();
      this.form.controls["adminArea"].updateValueAndValidity();
    }

    this.form.value.positionId = this.form.value.position.id;
    this.form.value.userTypeId = this.form.value.userType.id;
    this.form.value.roleIds = this.roleIds;
    this.form.value.adminAreaId = this.formData.adminAreaId;
    this.form.value.name = this.mixins.concatenate([
      this.form.value.firstName.toUpperCase(),
      this.form.value.middleName.toUpperCase(),
      this.form.value.lastName.toUpperCase(),
    ]);

    //console.log("saving payload", this.mixins.cleanObjects(this.form.value));
    this.saveFunction.emit(this.mixins.cleanObjects(this.form.value));
    //this.closeDialog();
  }
  closeDialog() {
    this.dialogRef.close();
    this.formData = {};
  }

  assignRoles(data, event) {
    const params = {
      id: data.id,
    };
    /** checking for either updating current
     * roles then use this.formData.roles
     *  or creating new array with objects or empty
     * */

    if (this.formData && this.formData.roles) {
      this.formData.roles = this.formData.roles;
    } else {
      this.formData.roles = [];
    }

    /** if role has been checked and true then push  */
    if (event.checked === true) {
      this.formData.roles.push(params);
    }
    if (this.formData.roles.length > 0) {
      const el = this.formData.roles.find((entry) => entry.id === data.id);

      const index = this.formData.roles.findIndex(
        (entry) => entry.id === data.id
      );

      if (el && event.checked === false) {
        this.formData.roles.splice(index, 1);
        this.roleIds.revokeRole =
          true; /** column for backend  check to remove user role(s) */
      }
    }

    this.roleIds = this.formData.roles.map((r) => r.id);
    /** clear errors when  roles has been selected */
    if (this.roleIds.length > 0) {
      this.form.controls["roles"].clearValidators();
      this.form.controls["roles"].updateValueAndValidity();
    }
  }

  getRoles(data) {
    this.roleIds = data.map((r) => r.id);
    /** clear errors when  roles has been selected */
    if (this.roleIds.length > 0) {
      this.form.controls["roles"].clearValidators();
      this.form.controls["roles"].updateValueAndValidity();
    }
  }

  selectedArea(data) {
    this.selected = data;
    this.formData.adminAreaId = data.id;
    /** clear form error when user has selected location */
    if (this.formData.adminAreaId) {
      this.form.controls["adminArea"].clearValidators();
      this.form.controls["adminArea"].updateValueAndValidity();
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      //name: ['', Validators.required],
      firstName: [
        "",
        [
          Validators.required,
          // Validators.pattern("^[A-Za-z's.,]+$"),
          Validators.minLength(3),
        ],
      ],
      middleName: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z's.,]+$"),
          Validators.minLength(3),
        ],
      ],

      // middleName: [""],
      lastName: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z]+$"),
          Validators.minLength(3),
        ],
      ],
      checkNumber: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
        ],
      ],

      mobileNumber: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      // position: [""],
      position: ["", Validators.required],
      userType: [this.formData.userType, Validators.required],
      // userType: [""],
      adminArea: [this.formData.adminArea],
      roles: [""],
      id: [null],
    });

    this.form.patchValue(this.formData);
    //console.log('formData patched', this.form.patchValue(this.formData))
  }

  filterRoles(data) {
    this.formData.rolesData = this.mixins.filterData(
      data,
      this.formData.rolesData
    );
  }

  get currentUser() {
    return this.mixins.currentUser;
  }

  get isNationalUser() {
    let areaType = this.mixins.currentUser?.adminArea?.areaType;
    return areaType.id === 17 || areaType.name.toLowerCase() === "country"
      ? true
      : false;
  }
}
